'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.kubernetes.namespace.selectField.directive', [])
  .directive('namespaceSelectField', function () {
    return {
      restrict: 'E',
      templateUrl: require('./selectField.directive.html'),
      scope: {
        namespaces: '=',
        component: '=',
        field: '@',
        columns: '@',
        account: '=',
        onChange: '&',
        hideLabel: '=',
      }
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/namespace/selectField.directive.js